import { UrlHelper } from '@bridebook/web/lib/url-helper';

// Where in the app a planner entry point was used, as analytics names it.
export type PlannerEntryLocation =
  | 'home'
  | 'search'
  | 'planningTools'
  | 'checklist'
  | 'guestList'
  | 'budget'
  | 'advice'
  | 'visionBoard'
  | 'weddingWebsite'
  | 'messages'
  | 'favourites'
  | 'settings'
  | 'inspiration'
  | 'quizzes'
  | 'supplierProfile'
  | 'other';

/**
 * Page routes, without the market, and the location each one counts as. A route matches
 * itself and every route under it. Matched on the route pattern, not the URL, so slugs,
 * ids and query params never change the result.
 */
const ROUTE_LOCATIONS: [route: string, location: PlannerEntryLocation][] = [
  [UrlHelper.home, 'home'],
  [UrlHelper.search, 'search'],
  [UrlHelper.planning, 'planningTools'],
  [UrlHelper.checklist.main, 'checklist'],
  [UrlHelper.guestlist.main, 'guestList'],
  [UrlHelper.events.main, 'guestList'],
  [UrlHelper.budget.main, 'budget'],
  [UrlHelper.advice, 'advice'],
  [UrlHelper.article.main, 'advice'],
  [UrlHelper.author.main, 'advice'],
  [UrlHelper.authorPage.main, 'advice'],
  [UrlHelper.weddingVision.main, 'visionBoard'],
  [UrlHelper.website.main, 'weddingWebsite'],
  [UrlHelper.inbox.main, 'messages'],
  [UrlHelper.shortlist.main, 'favourites'],
  [UrlHelper.settings.main, 'settings'],
  [UrlHelper.inspiration, 'inspiration'],
  [UrlHelper.savedInspiration, 'inspiration'],
  [UrlHelper.quizzes, 'quizzes'],
  [UrlHelper.supplier, 'supplierProfile'],
];

// Maps a Next.js route pattern, such as `/[market]/checklist/[id]`, to its location.
export const getPlannerEntryLocation = (routePattern: string): PlannerEntryLocation => {
  const route = routePattern.replace(/^\/\[market\]/, '') || '/';
  const match = ROUTE_LOCATIONS.find(
    ([prefix]) => route === prefix || route.startsWith(`${prefix}/`),
  );
  return match?.[1] ?? 'other';
};
